import { shallowEqual, useSelector } from 'react-redux';
import { StoreState } from 'store';

export const useSubscription = () => {
  const { user } = useSelector((state: StoreState) => state.user, shallowEqual);

  const subscription = user?.subscription;
  const subscriptionStatus = user?.subscription?.subscription_status;
  const isSubscriptionActive = subscriptionStatus && ['active', 'trialing', 'past_due'].includes(subscriptionStatus);

  const subscriptionPlan = subscription?.subscription_plan;

  return {
    isSubscriptionActive: !!isSubscriptionActive,
    subscription,
    subscriptionPlan,
  };
};
